import moment from 'moment';
import MomentUtils from '@date-io/moment';
import 'moment/locale/es';

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Slide,
} from '@material-ui/core';

import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { Search } from '@material-ui/icons';

import useStyles from './styles';

import SelectorServicio from '../SelectorServicio';
import Loading from '../Skeleton';
import Backdrop from '../Backdrop';

//actions
import {
  setterBusqueda,
  getServicios,
  setSelectedServicioIda,
  resetBusquedaAction,
} from '../../../redux/actions/serviciosActions';
import { enviarAutorizacion } from '../../../redux/actions/autorizacionActions';

moment.locale('es');

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function AlertDialog({ open, setOpen, autorizacion }) {
  const classes = useStyles();
  const [locale] = useState('es');

  const [fecha, setFecha] = useState(moment().toDate());
  const [buscando, setBuscando] = useState(false);

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [success, setSuccess] = useState(false);

  const dispatch = useDispatch();

  const disableWeekends = (date) => {
    return moment(date).isoWeekday() === 6 || moment(date).isoWeekday() === 7;
  };

  const token = useSelector((state) => state.auth.token);
  const { solicitudID, error } = useSelector((state) => state.autorizaciones);
  const { serviciosSeleccionados } = useSelector((state) => state.servicios);
  const servicios = useSelector((state) => state.servicios.servicios.ida);
  const servicioSelected = useSelector(
    (state) => state.servicios.serviciosSeleccionados.ida
  );
  const handleClose = () => {
    dispatch(resetBusquedaAction());
    setOpen(false);
    setBuscando(false);
  };

  const handleDateChange = (date) => {
    setFecha(date);
  };

  const query = {
    busqueda: {
      fecha,
      hora: autorizacion.servicio.desde.fecha,
      horarioAprox: 'salida',
      estacionOrigen: autorizacion.servicio.desde.id,
      estacionDestino: autorizacion.servicio.hasta.id,
    },
    cantidad: autorizacion.cantidad,
  };

  const handleBuscarServicios = () => {
    dispatch(
      getServicios({
        ida: true,
        token,
        query,
        numeroTrenFiltro: autorizacion.servicio.numero,
      })
    );
    dispatch(setterBusqueda(query.busqueda));
    setBuscando(true);
  };

  const handleAgregarAutorizacion = () => {
    // if (!solicitudID) dispatch(getSolicitudId(token));

    const autorizacionObj = {
      serviciosSeleccionados,
    };

    dispatch(enviarAutorizacion(token, solicitudID, autorizacionObj, setSuccess));
    setOpen(false);
    setOpenBackdrop(true);
    setBuscando(false);
    dispatch(resetBusquedaAction());
  };

  useEffect(() => {
    if (error) {
      setOpenBackdrop(false);
    }
  }, [error]);

  useEffect(() => {
    if (success) {
      setSuccess(false);
      setOpenBackdrop(false);
    }
  }, [success]);

  return (
    <div>
      <Backdrop open={openBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
        fullWidth={true}
        maxWidth={'md'}
        TransitionComponent={Transition}
      >
        <DialogTitle id='form-dialog-title' className={classes.titleDialog}>
          Agregar viaje
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} className={classes.container}>
            <Grid item xs={12} sm={12}>
              <MuiPickersUtilsProvider
                libInstance={moment}
                utils={MomentUtils}
                locale={locale}
              >
                <DatePicker
                  className={classes.formControl}
                  margin='normal'
                  id='date-picker-dialog'
                  label='Seleccione el dia'
                  cancelLabel='Cancelar'
                  clearLabel='Limpiar'
                  okLabel='Aceptar'
                  format='DD/MM/yyyy'
                  shouldDisableDate={disableWeekends}
                  minDate={moment().toDate()}
                  maxDate={moment().add(5, 'days').toDate()}
                  value={fecha}
                  onChange={handleDateChange}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant='contained'
                // color='primary'
                color='secondary'
                startIcon={<Search />}
                onClick={handleBuscarServicios}
                className={classes.button}
              >
                Buscar Servicios
              </Button>
              <br />
              <br />
            </Grid>
            {servicios !== null ? (
              <SelectorServicio
                servicios={servicios}
                servicioSelected={servicioSelected}
                selectedServicioRedux={setSelectedServicioIda}
              />
            ) : buscando ? (
              <Loading />
            ) : (
              ''
            )}
          </Grid>
        </DialogContent>
        <DialogActions className={classes.footerModalAction}>
          <Button onClick={handleClose} color='primary'>
            Cancelar
          </Button>
          {servicioSelected !== null && (
            <Button onClick={handleAgregarAutorizacion} color='primary'>
              Agregar viaje
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
